export default class DocumentStatusPollingGeneralError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DocumentStatusPollingGeneralError';
  }
}
